import { compose } from 'redux';

import type { AlertsState } from '../alertsStore';

const selectAlertsDomain = (state: AlertsState) => state.alerts;

export const selectAlertsData = compose(
  (state) => state.alertsData,
  selectAlertsDomain
);
